import { z } from 'zod';
/**
 * Solo play.
 *
 *  - `free`      : the player practises and the app tracks breaks and points
 *  - `challenge` : a set ball layout with a pass mark, scored for completion
 *
 * Challenges are not authored yet. The shape is fixed now so that practice
 * sessions recorded today keep their meaning once layouts exist, rather than
 * needing a migration.
 */
export const PracticeModeSchema = z.enum(['free', 'challenge']);
/** Broad skill a challenge exercises. Used to group the challenge library. */
export const ChallengeDisciplineSchema = z.enum([
    'potting',
    'positional',
    'break_building',
    'safety',
    'clearance',
]);
export const StartPracticeSchema = z.object({
    mode: PracticeModeSchema.default('free'),
    challengeId: z.string().min(1).optional(),
});
/**
 * The result of a session. Sent once at the end rather than shot by shot:
 * solo practice has no opponent to dispute it, so there is nothing for an
 * event log to protect.
 */
export const FinishPracticeSchema = z.object({
    pointsScored: z.number().int().nonnegative(),
    ballsPotted: z.number().int().nonnegative(),
    highestBreak: z.number().int().nonnegative(),
    breaks: z.array(z.number().int().nonnegative()).max(500).default([]),
    /** Challenge runs only: raw score and how much of the layout was cleared. */
    score: z.number().int().nonnegative().optional(),
    completion: z.number().min(0).max(1).optional(),
});
export function challengePassed(challenge, score) {
    return score >= challenge.maxScore * challenge.passMark;
}
//# sourceMappingURL=practice.js.map